// removed by extract-text-webpack-plugin
module.exports = {"container":"PrematchEventList__container__1ALf4","showsExtraBets":"PrematchEventList__showsExtraBets__PETDM","hidesExtraBets":"PrematchEventList__hidesExtraBets__F3WRE"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/PrematchEventList/PrematchEventList.css
// module id = 484
// module chunks = 0